import { Mail, Calendar, Eye, FileText, Handshake, Bot } from "lucide-react"
import { cn } from "@/lib/utils"
import type { Activity } from "@/lib/types"

const iconMap = {
  email: Mail,
  meeting: Calendar,
  view: Eye,
  update: Bot,
  deal: Handshake,
}

const colorMap = {
  email: "bg-blue-100 text-blue-600",
  meeting: "bg-purple-100 text-purple-600",
  view: "bg-amber-100 text-amber-600",
  update: "bg-primary/10 text-primary",
  deal: "bg-emerald-100 text-emerald-600",
}

function timeAgo(timestamp: string) {
  const now = new Date("2026-02-06T12:00:00Z")
  const date = new Date(timestamp)
  const diffMs = now.getTime() - date.getTime()
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
  if (diffHours < 1) return "Just now"
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays}d ago`
}

export function ActivityFeed({ activities }: { activities: Activity[] }) {
  return (
    <div className="glass-strong rounded-xl p-5 shadow-sm">
      <h3 className="text-base font-semibold text-foreground">Recent Activity</h3>
      <div className="mt-4 flex flex-col gap-3">
        {activities.map((activity) => {
          const Icon = iconMap[activity.type]
          return (
            <div
              key={activity.id}
              className="flex items-start gap-3 rounded-lg p-2.5 transition-colors hover:bg-accent/50"
            >
              <div
                className={cn(
                  "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg",
                  colorMap[activity.type]
                )}
              >
                <Icon className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">
                  {activity.title}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {activity.description}
                </p>
              </div>
              <span className="shrink-0 text-xs text-muted-foreground">
                {timeAgo(activity.timestamp)}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
